import type { FC } from 'react';

import { Spinner } from './Spinner';

/** Полупрозрачный оверлей с центрированным спиннером (для логина и т.п.). */
export const LoadingOverlay: FC = () => (
  <div
    className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/80"
    role="status"
    aria-live="polite"
    aria-label="Загрузка"
  >
    <Spinner size="lg" />
    <p className="mt-4 text-sm text-[#151515]/60">Загрузка</p>
  </div>
);
